<template>
  <div>
    <common-dialog
      ref="dialog"
      width="700px"
      :show-save-button="!readonly"
      unit="员工资料"
      edit-title
      id-key="ClassId"
      :data="data"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      @details-opened="onDetailsOpened"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @closed="dpId=null"
      close-on-saved
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        基本信息
        <el-row class="row-border">
          <el-col :span="12">
            <el-form-item label="人员工号" prop="EmpNo">
              <el-input v-if="setNum&&create" v-model="data.EmpNo" placeholder="请填写人员工号"></el-input>
              <span v-else>{{data.EmpNo}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="人员姓名" prop="EmpName">
              <el-input v-model="data.EmpName" :placeholder="readonly?'':'请填写人员姓名'" :disabled="readonly"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号码" prop="Mobile">
              <el-input v-model="data.Mobile" type="number" :placeholder="readonly?'':'请填写手机号码'" :disabled="readonly"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="家庭地址" prop="HomeAddress">
              <el-input v-model="data.HomeAddress" :placeholder="readonly?'':'请填写家庭地址'" :disabled="readonly"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属部门" prop="DpId">
              <el-select v-model="data.DpId" style="height:27px;margin-top:-3px;" :disabled="readonly">
                <el-option v-for="item in dpList" :key="item.DpId" :value="item.DpId" :label="item.DpName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="职务" prop="Job">
              <el-select size="small" v-model="data.Job" style="height:28px;margin-top:-3px;" :disabled="readonly">
                <el-option v-for="item in jobList" :key="item.OtherId" :value="item.OtherValue" :label="item.OtherValue"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="当前状态" prop="Status">
              <el-radio v-model="data.Status" :label="1" :disabled="readonly">在职</el-radio>
              <el-radio v-model="data.Status" :label="0" :disabled="create||readonly">离职</el-radio> 
              <!-- 新建不能选离职 -->
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="入职时间" prop="EntryDate">
              <el-date-picker
                v-model.trim="data.EntryDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择时间"
                style="width:100%;"
                :disabled="readonly"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="data.Status==0">
            <el-form-item label="离职时间" prop="LeaveDate">
              <el-date-picker
                v-model.trim="data.LeaveDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择时间"
                style="width:100%;"
                :disabled="readonly"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
// import otherApi from "@/api/basic/other";
import parmApi from "@/api/sy/parm";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        EmpId: 0,
        EmpNo: "",
        EmpName: "",
        Mobile: "",
        HomeAddress: "",
        Pid: 0,
        EntryDate: "",
        LeageDate: "",
        JobId: null,
        Job: "",
        Status: 1,
        DpId: 0,
      },
      setNum: false,
      dpId: null,
      readonly: false,
      create: false,
      jobList: [],
      dpList: [],
      api: require("@/api/basic/member").default,
      DpApi: require("@/api/basic/dp").default,
      // otherApi,
      parmApi,
      rules: {
        EmpNo: [{ required: true, message: "人员工号不能为空" }],
        EmpName: [{ required: true, message: "人员姓名不能为空" }],
        DpId: [{ required: true, message: "请选择所属部门" }],
        Mobile: [
          { required: false, message: "手机号码不能为空" },
          { validator: this.$commonJs.validateRules.validPhone },
        ],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened(row) {
      this.create = true;
      this.dpId = row.DpId;
      this.data.DpId = null;
      this.getOption();
      this.parmApi.getCode("员工资料").then(res => {
        if(res.Data) {
          this.data.EmpNo = res.Data
        } else {
          this.setNum = true
        }
      })
    },
    onEditOpened(row) {
      this.create = false;
      this.getOption()
    },
    onDetailsOpened(row) {
      this.readonly = true
      this.onEditOpened(row)
    },
    getOption() {
      // this.otherApi.list({ OtherType: '职务' }).then(res => {
      //   this.jobList = res.Data
      // })
      this.DpApi.list({DpId:0}).then(res => {
        // res.Data.forEach(e => {
        //   if(e.DpId != this.data.DpId) {
        //     this.dpList.push(e)
        //   }
        // });
        this.data.DpId = this.dpId||null;
        this.dpList = [{ DpId: 0, DpName: '无' }].concat(res.Data)
      })
    }
  },
};
</script>
<style lang="scss">
</style>